
import DateTimeService from './DateTimeService';
import { IBirthdayUser } from './../interfaces/IBirthdayUser';
import { Environment } from './Environment';
import { IBirthdayProps } from './../components/birthdays/Birthdays';
import { LocalizationService } from './LocalizationService';
import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';

const MILLISECONDS_IN_DAY: number = 86400000;

export default class BirthdayService {

  public static getBirthdays(props: IBirthdayProps): Promise<IBirthdayUser[]> {
    const today = new Date();
    const endDate = new Date();
    if (props.numDays) {
      endDate.setDate(endDate.getDate() + props.numDays);
    }

    const queryText = props.type === "Birthday" ? this.getSearchQuery('IABirthday', today, endDate, false) : this.getAnniversarySearchQuery('IAHireDate', today, endDate, props.years);
    // let sourceId = 'B09A7990-05EA-4AF9-81EF-EDFAB16C4E31';
    // let endpoint = `https://${tenant}.sharepoint.com/_api/search/query?querytext='${queryText}'&sourceid='${sourceId}'&trimduplicates=false&rowlimit=100&startRow=0&selectProperties='${properties}'`;
    // const site = "rootsite";
    const unicodedSearchQuery = queryText?.replace(/[+]/gi, '%2b') || "";
    const url = `${Environment.getEnvironmentForMainAPI(props.environment)}/api/${props.tenant}/birthday/profiles`;
    const body: string = JSON.stringify({
      "rowLimit": props.numDays,
      "startRow": 0,
      "searchQuery": unicodedSearchQuery,
      "anniversaryValue": "",
      "birthdayValue": ""
    });
    return new Promise<IBirthdayUser[]>((resolve) => {
    new FetchProxy(
      url, {
      method: "POST",
      headers: {
        'AuthToken': props.token,
        'Content-Type': 'application/json'
      },
      body: body
    })
    .withContainer(sdkContainerInstance)
    .fetch()
    .then((results) => {
      // if(!results.ok){
        
      // }
      return results.json();
    }).then((users) => {
      const people = [];
      let priorDates = [];
      let nextDates = [];
      const compareDate = new DateTimeService().getDateAtMidnight(new Date(today));
      if (props.type === "Birthday") {
        compareDate.setFullYear(2000);
      }
      const parameter = props.type === "Anniversary" ? "anniversary" : "birthday";
      const nameKey = "name";
      if (users.people) {
        users.people.forEach(user => {
          let anniversaryText;
          let birthdayText;
          let anniversary;
          let birthday;
          let isToday;

          if (props.type === "Anniversary") {
            const auxDate = new DateTimeService().getDateAtMidnight(new Date());
            auxDate.setFullYear(2000);
            /**
             * When the anniversary is in the future, it might be after months and eventually another year.
             * Make sure we know what the year is in the future.
             */
            const dateNow = new Date();
            dateNow.setHours(0, 0, 0, 0);
            const anniversaryDate = new Date(user.anniversary);
            const anniversaryDateFuture = new Date(dateNow.getFullYear(), anniversaryDate.getMonth(), anniversaryDate.getDate(), anniversaryDate.getHours(), anniversaryDate.getMinutes(), anniversaryDate.getSeconds());
            if (anniversaryDateFuture < dateNow) {
              anniversaryDateFuture.setFullYear(dateNow.getFullYear() + 1);
            }
            const daysUntilTheEventDiff = Math.ceil((anniversaryDateFuture.getTime() - dateNow.getTime()) / MILLISECONDS_IN_DAY);
            const eventTimeDate = new Date();
            eventTimeDate.setDate(eventTimeDate.getDate() + daysUntilTheEventDiff);
            const year = eventTimeDate.getFullYear() - (anniversaryDate.getFullYear());
            anniversaryText = `${year} ${new LocalizationService().strings.Birthday_Years} - ${this.getDateText(new Date(user.anniversary))}`;
            anniversary = new DateTimeService().getDateAtMidnight(new Date(user.anniversary));
            isToday = (today.getDate() === anniversary.getDate()) && today.getMonth() === anniversary.getMonth();
          } else {
            birthdayText = this.getDateText(new Date(user.birthday));
            birthday =  new DateTimeService().getDateAtMidnight(new Date(user.birthday));
            birthday.setFullYear(2000);
            isToday = (today.getDate() === birthday.getDate()) && today.getMonth() === birthday.getMonth();
          }

          const person: IBirthdayUser = {
            anniversary: anniversary,
            birthday: birthday,
            company: '',
            department: user.department,
            email: user.email,
            guid: user.guid,
            jobTitle: user.jobTitle,
            name: user.title,
            officeLocation: user.location,
            profilePicture: user.profilePicture,
            phone: user.phones,
            anniversaryText: anniversaryText,
            birthdayText: birthdayText,
            isToday: isToday
          };
          
          if (!props.enableFilter || (props.enableFilter && props.filterOptions && this.filter(props, person))) {
            if (this.isNextDate(person, parameter, compareDate)) {
              nextDates.push(person);
            } else {
              priorDates.push(person);
            }
            // people.push(person);
          }
        });
      }
      nextDates = nextDates.sort((d1, d2) => {
        const date1: Date = new Date(d1[parameter]);
        date1.setFullYear(2000);
        const date2: Date = new Date(d2[parameter]);
        date2.setFullYear(2000);
        if (date1 > date2) {
          return 1;
        } else if (date1 < date2) {
          return -1;
        } else if (parameter === "anniversary") {
          const year1 = (new Date(d1[parameter])).getFullYear();
          const year2 = (new Date(d2[parameter])).getFullYear();
          if (year1 > year2) {
            return 1;
          } else if (year1 < year2) {
            return -1;
          } else if (d1[nameKey] > d2[nameKey]) {
            return 1;
          } else {
            return - 1;
          }
        } else {
          if (d1[nameKey] > d2[nameKey]) {
            return 1;
          } else {
            return - 1;
          }
        }
      });

      priorDates = priorDates.sort((d1, d2) => {
        const date1: Date = new Date(d1[parameter]);
        date1.setFullYear(2000);
        const date2: Date = new Date(d2[parameter]);
        date2.setFullYear(2000);
        if (date1 > date2) {
          return 1;
        } else if (date1 < date2) {
          return -1;
        } else if (parameter === "anniversary") {
          const year1 = (new Date(d1[parameter])).getFullYear();
          const year2 = (new Date(d2[parameter])).getFullYear();
          if (year1 > year2) {
            return 1;
          } else if (year1 < year2) {
            return -1;
          } else if (d1[nameKey] > d2[nameKey]) {
            return 1;
          } else {
            return - 1;
          }
        } else {
          if (d1[nameKey] > d2[nameKey]) {
            return 1;
          } else {
            return - 1;
          }
        }
        
      });
      people.push(...nextDates);
      people.push(...priorDates);

      resolve(people);
    });
  });
    // https://{$tenant}.sharepoint.com/_api/search/query?querytext='*'&sourceid='B09A7990-05EA-4AF9-81EF-EDFAB16C4E31'&trimduplicates=false&rowlimit=100&startRow=0&selectProperties='TestHireDate,PIAHireDate,AccountName'
    // https://intraactivedev.sharepoint.com/_api/search/query?querytext=%27*%27&sourceid=%27B09A7990-05EA-4AF9-81EF-EDFAB16C4E31%27&trimduplicates=false&rowlimit=100&startRow=0&selectProperties=%27TestHireDate,PIAHireDate,AccountName%27
  }

  private static isNextDate(person: IBirthdayUser, parameter: string, today: Date) {
    const date: Date = person[parameter];
    const compareDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    compareDate.setFullYear(today.getFullYear());
    if (compareDate < today) {
      return false;
    } else {
      return true;
    }
  }


  private static getDateText(date: Date) {
    const today = new Date();
    if ((today.getDate() === date.getDate()) && today.getMonth() === date.getMonth()) {
        return new LocalizationService().strings.Birthday_Today;
    }
    if (navigator.language && (navigator.language.indexOf("da") !== -1)) {
      return `${date.getDate()}. ${(new DateTimeService().getNameOfMonth(date))?.toLocaleLowerCase()}`;
    }
    return `${(new DateTimeService().getNameOfMonth(date))} ${new DateTimeService().getDayInMonth(date)}`;
  }

  private static filter(props: IBirthdayProps, profile: IBirthdayUser): boolean {
    let show = true;
    const jobTitle = "jobTitle";
    const department = "department";
    const locations = "locations";
    if (props.filterOptions[jobTitle]) {
      show = props.filterOptions[jobTitle][profile.jobTitle] ? props.filterOptions[jobTitle][profile.jobTitle] : false;
      if (!show) {
        return show;
      }
    }
    if (props.filterOptions[department]) {
      show = props.filterOptions[department][profile.department] ? props.filterOptions[department][profile.department] : false;
      if (!show) {
        return show;
      }
    }
    if (props.filterOptions[locations]) {
      show = props.filterOptions[locations][profile.officeLocation] ? props.filterOptions[locations][profile.officeLocation] : false;
      if (!show) {
        return show;
      }
    }

    return show;
  }

  private static getSearchQuery(field: string, startDate: Date, endDate: Date, useYears: boolean): string {

    const isLeapYear = new Date(startDate.getFullYear(), 1, 29).getMonth() === 1;

    let queryText = "";
    if (startDate.getMonth() === 2 && startDate.getDate() === 0 && isLeapYear) {
      startDate.setDate(startDate.getDate() - 1);
    }

    const start = new Date(startDate.getTime());
    const end = new Date(endDate.getTime());
    const lastDayOfYear = new Date(startDate.getFullYear(), 11, 31);
    const firstDayOfYear = new Date(endDate.getFullYear() + 1, 0, 1);

    if (!useYears) {
      start.setFullYear(2000);
      end.setFullYear(2000);
      lastDayOfYear.setFullYear(2000);
      firstDayOfYear.setFullYear(2000);
    }

    if (end < start) {// year change
      queryText = "(" + this.getDateInterval(field, start, lastDayOfYear) + ") or (" + this.getDateInterval(field, firstDayOfYear, end) + ")";
    } else {
      queryText = this.getDateInterval(field, start, end);
    }

    return queryText;
  }

  private static getAnniversarySearchQuery(field: string, startDate: Date, endDate: Date, anniversaries: number[]): string {
    let query = "";

    let list = anniversaries;
    if (!list || list.length === 0) {
      list = [5];
    }

    for (const anniversary of list) {
      const start: Date = new Date(startDate.getTime());
      start.setFullYear(start.getFullYear() - anniversary);
      const end: Date = new Date(endDate.getTime());
      end.setFullYear(end.getFullYear() - anniversary);

      query += "(" + this.getSearchQuery(field, start, end, true) + ") or ";
    }

    if (query.length > 0) {
      query = query.slice(0, query.length - 3);
    }

    return query;
  }

  private static getDateInterval(field: string, startDate: Date, endDate: Date): string {
    return field + " ge " + "datetime'" + new DateTimeService().ConvertToYYYYMMDD(startDate) + "T00:00:00'" + " and " + field + " le " + "datetime'" +  new DateTimeService().ConvertToYYYYMMDD(endDate) + "T23:59:00'";
  }

}